<template>
  <div class="material">
    <div class="materialList">
      <img @click="onUpload"
           class="materialItem"
           title="新增图标"
           alt="新增图标"
           src="@/assets/image/add_new.png">
      <template v-for="(item,index) in iconList">
        <div class="materialItem" :key="index" v-if="!item.is_delete">
          <div class="close" @click="deleteIcon(item.id)">x</div>
          <img @dragstart="dragstart($event, item)"
               class="dragableIcon"
               :title="item.description"
               :alt="item.description"
               :src="item.url">
        </div>
      </template>
    </div>
    <el-dialog title="新增ICON"
               width="300px"
               :append-to-body="true"
               :visible.sync="addDialogVisible">
      <div style="font-weight:700;">
        <span>图标名称：</span>
        <el-input v-model="formData.description"
                  style="width:200px"
                  placeholder="请输入图标名称"
                  size="small" />
      </div>
      <div style="font-weight:700;margin:10px 0px;">
        <span>图标类型：</span>
        <el-select v-model="formData.type"
                   size="small"
                   style="width:200px"
                   placeholder="请选择图表类型"
                   clearable>
          <el-option
            v-for="(item, index) in iconTypeList"
            :key="index"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div style="margin:10px 0px;font-weight:700;">
        <span>上传图标：</span>
        <el-upload
          style="margin-top:10px;"
          ref="upload"
          action=""
          :accept="accept"
          :limit="1"
          :auto-upload="false"
          list-type="picture-card"
          :http-request="uploadIconFunc"
          :on-exceed="onExceed">
          <i class="el-icon-plus"></i>
        </el-upload>
        <div style="margin-top:20px;">
          <el-button type="primary" style="width:120px;" @click="submitUpload">上传</el-button>
          <el-button style="width:120px;margin-left:40px;" @click="addDialogVisible = false">取消</el-button>
        </div>

      </div>

    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable func-names */
import { createIcon, deleleIcon, queryAllIcon } from '@/api/map';

export default {
  name: 'material',
  components: { },
  props: {
    svgDom: {
      type: Object,
      default: () => null,
    },
    iconList: {
      type: Array,
      default: () => null,
    },
  },
  watch: {
    svgDom() {
      this.initEvent();
    },
  },
  data() {
    return {
      selectedIcon: null,
      addDialogVisible: false,
      isDragging: false,
      formData: {
        type: 'poi',
      },
      accept: 'image/svg+xml',
      iconTypeList: [
        { id: 'poi', name: '店铺' },
        { id: 'other', name: '其他' },
      ],
    };
  },
  computed: {
    floorId() {
      return this.$route.query.floor_id;
    },
    placeId() {
      return this.$route.query.place_id;
    },
  },
  created() {
  },
  beforeDestroy() {
  },
  mounted() {
  },
  methods: {
    onUpload() {
      // this.$refs.uploader.click();
      this.addDialogVisible = true;
    },
    onExceed() {
      this.$message.warning('只能上传一张图片');
    },
    submitUpload() {
      if (!this.formData.description) {
        this.$message.error('请输入名称');
        return;
      } if (!this.formData.type) {
        this.$message.error('请选择图标类型');
        return;
      }
      this.$refs.upload.submit();
    },
    uploadIconFunc(data) {
      const file = data.file;
      if (!file) {
        this.$message.error('请上传文件');
        return;
      }
      const fileReader = new FileReader();
      if (file) {
        // if (file.type === 'image/svg+xml') map_type = 'cmap';
        // if (file.type === 'image/jpeg' || file.type === 'image/png') map_type = '2d';
        fileReader.readAsDataURL(file);
        const self = this;
        fileReader.onload = function () {
          // 查看文件输出内容
          self.formData.map_file = this.result.replace(/data:image.*?,/gi, '');
          self.formData.place_id = self.placeId;
          createIcon({ data: self.formData }).then((res) => {
            self.addDialogVisible = false;
            self.$refs.upload.clearFiles();
            self.formData = {
              type: 'poi',
            };
            self.$emit('queryAllIcon');
          });
        };
      }
    },
    dragstart(e, item) {
      this.isDragging = true;
      this.selectedIcon = item;
      e.dataTransfer.setData('materailItem', JSON.stringify(item));
    },
    async deleteIcon(id) {
      const params = {
        params: {
          place_id: this.placeId,
          id,
        },
      };
      await deleleIcon(params);
      this.$emit('queryAllIcon');
    },

  },
};
</script>
<style lang="less" scoped>
  .material{
    width: 100%;
    // height: 100vh;
    background-color: #1c1c1e;
    border-top:1px solid #232323;
    box-shadow: 1px 2px 2px 232323;
    // position: fixed;
    // left: 0;
    // top: 0;
    margin-top: 36px;
    z-index: 10;
    padding: 0px 0px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    // align-items: center;
    .materialList{
      width: 100%;
      border-radius: 10px;
      background-color: #2c2c2e;
      padding: 10px 10px 0 10px;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;

      .materialItem{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        margin-right: 10px;
        margin-bottom: 10px;
        position: relative;
        cursor: pointer;
        &:hover{
          .close{
            display: block;
          }
        }
        .close{
          width: 14px;
          height: 14px;
          color: #fff;
          position: absolute;
          right: -5px;
          top: -5px;
          font-size: 12px;
          text-align: center;
          line-height: 12px;
          background-color: #e57471;
          border-radius: 50%;
          display: none;
          cursor: pointer;
          &:hover{
            background-color: #ce2520;
          }
        }
      }
      .dragableIcon{
          width: 30px;
          height: 30px;
          fill: #565657;
        }
    }
    .formLabel{
      margin-top: 20px;
      span{
        font-weight: 700;
      }
    }
  }
</style>
